import styles from './loader.module.scss';

const Loader = (props) => <div className={`${styles.loader} ${props.customClass || ''}`} style={props.customStyle} />;

export default Loader;
